module.exports = __webpack_public_path__ + "static/GilroyAlt-Bold-3dfb7967dfdafd1c710cd95efffa9fde.woff2";